import { useQuery } from '@tanstack/react-query'
import { useApi } from 'service/useApi'

export const useCargoTypeQuery = () => {
  const API = useApi()

  return useQuery({
    queryKey: ['cargo-type-list'],
    queryFn: async () => {
      const list = await API.cargoType.get()
      return Array.isArray(list) ? list : []
    },
    initialData: [],
    retry: 3,
  })
}
